function IconTrophy() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path
        d="M20 12H44V20C44 28 39 34 32 36C25 34 20 28 20 20V12Z"
        stroke="#F5B400"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path d="M20 16H12V20C12 25 16 29 21 29" stroke="#F5B400" strokeWidth="3" strokeLinejoin="round" />
      <path d="M44 16H52V20C52 25 48 29 43 29" stroke="#F5B400" strokeWidth="3" strokeLinejoin="round" />
      <path d="M32 36V46" stroke="#F5B400" strokeWidth="3" />
      <path d="M24 52H40" stroke="#F5B400" strokeWidth="3" strokeLinecap="round" />
      <path d="M26 46H38" stroke="#F5B400" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}

function IconPartnership() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="22" cy="18" r="5" stroke="#F5B400" strokeWidth="3" />
      <circle cx="42" cy="18" r="5" stroke="#F5B400" strokeWidth="3" />
      <path d="M12 32C12 26 16 23 22 23C28 23 32 26 32 32" stroke="#F5B400" strokeWidth="3" />
      <path d="M32 32C32 26 36 23 42 23C48 23 52 26 52 32" stroke="#F5B400" strokeWidth="3" />
      <path d="M22 42L28 48C30 50 34 50 36 48L42 42" stroke="#F5B400" strokeWidth="3" strokeLinecap="round" />
      <path d="M26 38L32 44L38 38" stroke="#F5B400" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}

function IconGrowth() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path d="M12 52H52" stroke="#F5B400" strokeWidth="3" />
      <path d="M18 52V36" stroke="#F5B400" strokeWidth="4" strokeLinecap="round" />
      <path d="M30 52V26" stroke="#F5B400" strokeWidth="4" strokeLinecap="round" />
      <path d="M42 52V16" stroke="#F5B400" strokeWidth="4" strokeLinecap="round" />
      <path
        d="M16 22L28 14L38 20L52 8"
        stroke="#F5B400"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M46 8H52V14" stroke="#F5B400" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}

export const achievementsMilestoneIcons = {
  trophy: IconTrophy,
  partnership: IconPartnership,
  growth: IconGrowth,
}
